module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-600-02faed9f2938bbba57514dfbea590d56.woff";